import { render } from "./CategoriasList.vue?vue&type=template&id=40509ceb&scoped=true"
import script from "./CategoriasList.vue?vue&type=script&lang=js"
export * from "./CategoriasList.vue?vue&type=script&lang=js"

import "./CategoriasList.vue?vue&type=style&index=0&id=40509ceb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40509ceb"]])

export default __exports__